import { render } from "./HeroiconsOutlineShoppingBag.vue?vue&type=template&id=65b3cf67"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineShoppingBag.vue"]])

export default __exports__